import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { StaticPage, TopbarContainer } from '../../containers';
// Import StaticPage and layout wrappers
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  NamedLink,
  Footer, // Import Footer
} from '../../components';
import { cityContent } from '../../data/cityLandingContent';
//import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import { twitterPageURL } from '../../util/urlHelpers'; // Import necessary props for Footer

import css from './LandingPageCities.module.css';

// Helper function to format city names (e.g., palmaDeMallorca -> Palma De Mallorca)
export const formatCityName = cityNameKey => {
  return cityNameKey
    .replace(/([A-Z])/g, ' $1') // Add space before capital letters
    .replace(/^./, str => str.toUpperCase()); // Capitalize the first letter
};

const LandingPageCitiesComponent = props => {
  const { intl } = props;

  const title = intl.formatMessage({ id: 'LandingPageCities.title' });
  const description = intl.formatMessage({ id: 'LandingPageCities.description' });
  // Use schemaTitle and schemaDescription for StaticPage schema prop
  const schemaTitle = title;
  const schemaDescription = description;

  const cityEntries = Object.entries(cityContent);

  return (
    // Use StaticPage instead of Page
    <StaticPage
      title={title}
      description={description} // Pass description
      schema={{ // Pass schema object
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
        description: schemaDescription,
      }}
    >
      {/* Use explicit layout wrappers */}
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          {/* Pass currentPage prop if needed by TopbarContainer */}
          <TopbarContainer currentPage="LandingPageCities" />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain>
          {/* Keep the existing main content structure */}
          <div className={css.root}>
            <div className={css.content}>
              <h1 className={css.mainTitle}>
                <FormattedMessage id="LandingPageCities.mainTitle" />
              </h1>
              {/* <p className={css.mainDescription}>
                <FormattedMessage id="LandingPageCities.mainDescription" />
              </p> */}
              <div className={css.cityGrid}>
                {cityEntries.map(([key, cityData]) => {
                  const cityLocalized = intl.formatMessage({ id: `LandingPageCities.${key}` });
                  const city = cityLocalized === `LandingPageCities.${key}` ? key : cityLocalized

                  return (
                    <NamedLink key={key} name={cityData.routeName} className={css.cityCard}>
                      <div
                        className={css.cityImage}
                        style={{ backgroundImage: `url(${cityData.image})` }}
                      />
                      <div className={css.cityName}>
                        {formatCityName(city)}
                      </div>
                    </NamedLink>
                  )
                })}
              </div>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          {/* Use Footer component directly */}
          <Footer twitterPageURL={twitterPageURL} />
          {/* Or keep FooterContainer if preferred */}
          {/* <FooterContainer /> */}
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage> // Close StaticPage
  );
};

LandingPageCitiesComponent.propTypes = {
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  // Typically you might map state here if needed
  return {};
};

const LandingPageCities = compose(
  connect(mapStateToProps),
  injectIntl
)(LandingPageCitiesComponent);

export default LandingPageCities;
